module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="tabs tabs-internal">\n    <span class="tab active" data-tab-name="widget">Salesforce Commerce Cloud Product Widget</span>\n    <span class="tab " data-tab-name="quick-view-action" >Salesforce Commerce Cloud QuickView Action</span>\n    ';
 if (isScene7Enabled) { ;
__p += '\n        <span class="tab " data-tab-name="adobe-scene-7" >Adobe Scene7</span>\n    ';
 } ;
__p += '\n    ';
 if (isShopifyMenuEnabled) { ;
__p += '\n        <span class="tab " data-tab-name="shopify-store">Shopify</span>\n    ';
 } ;
__p += '\n</div>\n<div class="tab-pane active widget" data-tab-pane="widget"></div>\n<div class="tab-pane quick-view-action" data-tab-pane="quick-view-action"></div>\n';
 if (isScene7Enabled) { ;
__p += '\n    <div class="tab-pane adobe-scene-7" data-tab-pane="adobe-scene-7"></div>\n';
 } ;
__p += '\n';
 if (isShopifyMenuEnabled) { ;
__p += '\n    <div class="tab-pane shopify-store" data-tab-pane="shopify-store"></div>\n';
 } ;


}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/settings/integrations/addOns/AddOnsView.tpl
// module id = 3063
// module chunks = 0